import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { useTranslation } from 'react-i18next';
import { TOOLTIP_STYLE } from './chartTheme';

interface DonutDatum {
  name: string;
  value: number;
  color: string;
}

interface CostDonutChartProps {
  data: DonutDatum[];
  centerLabel?: string;
  centerValue?: string;
}

export function CostDonutChart({ data, centerLabel, centerValue }: CostDonutChartProps) {
  const { t } = useTranslation('common');
  const filtered = data.filter((d) => d.value > 0);

  if (filtered.length === 0) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#94a3b8', fontSize: 13 }}>
        {t('noCostData', 'Aucune donnée de coûts')}
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={filtered}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={90}
          dataKey="value"
          stroke="rgba(22,22,37,0.6)"
          strokeWidth={2}
        >
          {filtered.map((entry, i) => (
            <Cell key={i} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={TOOLTIP_STYLE}
          formatter={(val: number) => [
            new Intl.NumberFormat('fr-CH', { style: 'currency', currency: 'CHF', maximumFractionDigits: 0 }).format(val),
            '',
          ]}
        />
        {(centerLabel || centerValue) && (
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle">
            {centerValue && (
              <tspan x="50%" dy="-6" fill="#f1f5f9" fontSize="16" fontFamily="'Inter', serif">
                {centerValue}
              </tspan>
            )}
            {centerLabel && (
              <tspan x="50%" dy={centerValue ? '18' : '0'} fill="#94a3b8" fontSize="11" fontFamily="'Inter', sans-serif">
                {centerLabel}
              </tspan>
            )}
          </text>
        )}
      </PieChart>
    </ResponsiveContainer>
  );
}
